import { MaintenanceTypeUpsertComponent } from '~/modules/assets/files/maintenance-type/upsert/upsert.component';
import { CopyBarcodeLabelComponent } from './../modules/stocks/labels/barcode-label/copy-barcode-label/copy-barcode-label.component';
import { ResetPasswordPopupComponent } from './../modules/stocks/users/reset-password-popup/reset-password-popup.component';
import { ReactivateDataComponent } from './../shared/components/reactivate-data/reactivate-data.component';
import { ComponentType } from '@angular/cdk/portal';
import { PageNames } from '~/models/pageNames';
import { StocksBarcodeLabelPrintUpsertComponent } from '~/modules/stocks/administration/barcode-setting/barcode-label-print-preferences/upsert/upsert.component';
import { StocksBarcodeGeneratorsUpsertComponent } from '~/modules/stocks/barcode-generators/upsert/upsert.component';
import { StocksAddressesUpsertComponent } from '~/modules/stocks/files/addresses/upsert/upsert.component';
import { StocksCategoriesUpsertComponent } from '~/modules/stocks/files/categories/upsert/upsert.component';
import { StocksCustomersUpsertComponent } from '~/modules/stocks/files/customers/upsert/upsert.component';
import { StocksItemsUpsertComponent } from '~/modules/stocks/files/items/upsert/upsert.component';
import { StocksLocationTypesUpsertComponent } from '~/modules/stocks/files/location-types/upsert/upsert.component';
import { StocksLocationsUpsertComponent } from '~/modules/stocks/files/locations/upsert/upsert.component';
import { StocksUnitOfMeasuresUpsertComponent } from '~/modules/stocks/files/unit-of-measure/upsert/upsert.component';
import { StocksVendorsUpsertComponent } from '~/modules/stocks/files/vendors/upsert/upsert.component';
import { customForecastComponent } from '~/modules/stocks/reports/forecast/custom-forecast/custom-forecast.component';
import { StandardForecastComponent } from '~/modules/stocks/reports/forecast/standard-forecast/standard-forecast.component';
import { StocksPicturesUpsertComponent } from '~/modules/stocks/Library/pictures/upsert/upsert.component';
import { StocksDocumentsUpsertComponent } from '~/modules/stocks/Library/Documents/upsert/upsert.component';
import { CustomReportComponent } from '~/modules/stocks/reports/report/custom-report/custom-report.component';
import { scheduleReportComponent } from '~/modules/stocks/reports/report/schedule/schedule.component';
import { StockReceiveComponent } from '~/modules/stocks/transactions/receive/receive.component';
import { StocksTransferRequestsUpsertComponent } from '~/modules/stocks/transfer-requests/upsert/upsert.component';
import { StocksUsersUpsertComponent } from '~/modules/stocks/users/upsert/upsert.component';
import { popupComponent } from '~/shared/components/popup/popup.component';
import { BuildYourAppsUpsertComponent } from '~/modules/stocks/administration/others/build-your-apps/upsert/upsert.component';
import { MobileAppGroupsUpsertComponent } from '~/modules/stocks/administration/others/mobile-app-groups/upsert/upsert.component';
import { SecurityLevelUpsertComponent } from '~/modules/stocks/administration/others/security-levels/upsert/upsert.component';
import { StockAdminPOApprovalsUpsertComponent } from '~/modules/stocks/administration/order/po-approvals/upsert/upsert.component';
import { StocksQuantityPerAccountComponent } from '~/modules/stocks/files/items/quantity-per-account';
import { StocksDeactivatingDataComponent } from '~/shared/components/deactivate-data/deactivate-data';
import { DisposeToLocationComponent } from '~/modules/stocks/transactions/dispose/dispose-to-location/dispose-to-location.component';
import { StockPurchaseOrdersUpsertComponent } from '~/modules/stocks/orders/purchase-orders/upsert/upsert.component';
import { StockSalesOrdersUpsertComponent } from '~/modules/stocks/orders/sales-orders/upsert/upsert.component';
import { StockPackComponent } from '~/modules/stocks/transactions/pack/pack.component';
import { StockShipComponent } from '~/modules/stocks/transactions/ship/ship.component';
import { StockKittingComponent } from '~/modules/stocks/transactions/kitting/kitting.component';
import { StockBreakdownComponent } from '~/modules/stocks/transactions/breakdown/breakdown.component';
import { StockAdjustInventoryComponent } from '~/modules/stocks/transactions/adjust-inventory/adjust-inventory.component';
import { StockPhysicalInventoryComponent } from '~/modules/stocks/transactions/physical-inventory/physical-inventory.component';
import { StockCycleCountComponent } from '~/modules/stocks/transactions/stock-cycle-count/stock-cycle-count.component';
import { StockCycleCountAdjustComponent } from '~/modules/stocks/transactions/stock-cycle-count-adjust/stock-cycle-count-adjust.component';
import { StockStockToAssetComponent } from '~/modules/stocks/transactions/stock to asset/stock-to-asset.component';
import { StockPicklistUpsertComponent } from '~/modules/stocks/lists/picklist/upsert/upsert.component';
import { ReportViewerPopupComponent } from '~/shared/components/viewer/popup.component';
import { DisposeToUpsertComponent } from '~/modules/stocks/files/dispose-to/upsert/upsert.component';
import { StockAdminSOApprovalsUpsertComponent } from '~/modules/stocks/administration/order/so-approvals/upsert/upsert.component';
import { BarcodeLabelUpsertComponent } from '~/modules/stocks/labels/barcode-label/upsert/upsert.component';
import { PublicQrUpsertComponent } from '~/modules/stocks/labels/public-qr/upsert/upsert.component';
import { BarcodeCatalogsUpsertComponent } from '~/modules/stocks/labels/barcode-catalogs/upsert/upsert.component';
import { DeparmtentsUpsertComponent } from '~/common/department/upsert/upsert.component';
import { StatusesUpsertComponent } from '~/modules/assets/files/status/upsert/upsert.component';
import { AssetTypeUpsertComponent } from '~/modules/assets/files/asset-type/upsert/upsert.component';
import { AssignedAssetsPopupComponent } from '~/modules/stocks/users/assigned-assets-popup/assigned-assets-popup.component';
import { StocksFacilityUpsertComponent } from '~/modules/stocks/files/Facility/upsert/upsert.component';
import { BuildingUpsertComponent } from '~/modules/stocks/files/building/upsert/upsert.component';
import { CustomerTypesUpsertComponent } from './../modules/stocks/files/customer-types/upsert/upsert.component';
import { FloorUpsertComponent } from './../modules/stocks/files/floor/upsert/upsert.component';
import { AssetModelUpsertComponent } from '~/modules/assets/files/asset-models/upsert/upsert.component';
import { AssetModelUpsert2Component } from '~/modules/assets/files/asset-models-2/upsert/upsert.component';
import { AssetUpsertComponent } from '~/modules/assets/files/asset/upsert/upsert.component';
import { StockVideosUpsertComponent } from '~/modules/stocks/Library/Videos/upsert/stock-videos-upsert.component';
import { FundingSourceUpsertComponent } from '~/modules/assets/files/fundingSource/upsert/upsert.component';
import { AssetAdminPOApprovalsUpsertComponent } from '~/modules/assets/administration/order/po-approvals/upsert/upsert.component';
import { ReportDesignerComponent } from '~/modules/stocks/reports/report/designer/reportdesigner.component';
import { AssetPurchaseOrdersUpsertComponent } from '~/modules/assets/orders/asset-purchase-orders/upsert/upsert.component';
import { AssetConditionsUpsertComponent } from '~/modules/assets/files/conditions/upsert/asset-conditions-upsert.component';
import { StocksConditionsUpsertComponent } from '~/modules/stocks/files/conditions/upsert/upsert.component';
import { MultiSiteUpsertComponent } from '~/common/sites/upsert/upsert.component';
import { AssetTransferUpsertComponent } from '~/modules/assets/transactions/transfer/upsert/asset-transfer-upsert.component';
import { AssetReservationUpsertComponent } from '~/modules/assets/transactions/asset-reservation/upsert/upsert.component';
import { CycleCountComponent } from '~/modules/assets/transactions/cycle-count/cycle-count.component';
import { ScheduleMaintenanceFormComponent } from '~/modules/assets/transactions/schedule-maintenance/form/schedule-maintenance-form.component';
import { PerformMaintenanceFormComponent } from '~/modules/assets/transactions/perform-maintenance/form/perform-maintenance-form.component';
import { StocksSiteTransferUpsertComponent } from '~/modules/stocks/site-transfers/upsert/upsert.component';

type formComponentMap = Record<string, ComponentType<any>>;

function isEnterpriseMode(): boolean {
  try {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      const u = JSON.parse(userStr);
      if (u && u.isEnterprise !== undefined) {
        return !!u.isEnterprise;
      }
    }
    if (localStorage.getItem('enterprise_user_accounts')) {
      return true;
    }
  } catch {}
  return false;
}

const componentMap: Record<string, () => ComponentType<any>> = {
  'stockItems': () => StocksItemsUpsertComponent,
  'categories': () => StocksCategoriesUpsertComponent,
  'customers': () => StocksCustomersUpsertComponent,
  'vendors': () => StocksVendorsUpsertComponent,
  'addresses': () => StocksAddressesUpsertComponent,
  'users': () => StocksUsersUpsertComponent,
  'persons': () => StocksUsersUpsertComponent,
  'scheduleReport': () => scheduleReportComponent,
  'transferRequests': () => StocksTransferRequestsUpsertComponent,
  'barcodeGenerators': () => StocksBarcodeGeneratorsUpsertComponent,
  'popup': () => popupComponent,
  'stock-custom-forecast': () => customForecastComponent,
  'stock-standard-forecast': () => StandardForecastComponent,
  'standard-forecast': () => StandardForecastComponent,
  'stock-custom-report': () => CustomReportComponent,
  'reports': () => CustomReportComponent,
  'report-reports': () => CustomReportComponent,
  'forecast': () => StandardForecastComponent,
  'report-forecast': () => StandardForecastComponent,
  'stock-forecast': () => StandardForecastComponent,
  'files': () => StocksPicturesUpsertComponent,
  'documents': () => StocksDocumentsUpsertComponent,
  'videos': () => StockVideosUpsertComponent,
  'locations': () => StocksLocationsUpsertComponent,
  'locationTypes': () => StocksLocationTypesUpsertComponent,
  'facility': () => StocksFacilityUpsertComponent,
  'building': () => BuildingUpsertComponent,
  'floor': () => FloorUpsertComponent,
  'uom': () => StocksUnitOfMeasuresUpsertComponent,
  'barcode-label-print': () => StocksBarcodeLabelPrintUpsertComponent,
  'receive': () => StockReceiveComponent,
  'mobileAppGroups': () => MobileAppGroupsUpsertComponent,
  'buildYourApps': () => BuildYourAppsUpsertComponent,
  'appRoles': () => SecurityLevelUpsertComponent,
  'purchaseOrders': () => StockPurchaseOrdersUpsertComponent,
  'salesOrders': () => StockSalesOrdersUpsertComponent,
  'poApprovals': () => StockAdminPOApprovalsUpsertComponent,
  'soApprovals': () => StockAdminSOApprovalsUpsertComponent,
  'quantity-per-account': () => StocksQuantityPerAccountComponent,
  'deactivate-data': () => StocksDeactivatingDataComponent,
  'reactivate-data': () => ReactivateDataComponent,
  'disposeToLocations': () => DisposeToLocationComponent,
  'pack': () => StockPackComponent,
  'ship': () => StockShipComponent,
  'kitting': () => StockKittingComponent,
  'breakdown': () => StockBreakdownComponent,
  'adjust-inventory': () => StockAdjustInventoryComponent,
  'pickList': () => StockPicklistUpsertComponent,
  'physical-inventory': () => StockPhysicalInventoryComponent,
  'stock-to-asset': () => StockStockToAssetComponent,
  'reportViewer': () => ReportViewerPopupComponent,
  'disposeTo': () => DisposeToUpsertComponent,
  'barcodeLabel': () => BarcodeLabelUpsertComponent,
  'barcode-label': () => BarcodeLabelUpsertComponent,
  'labels': () => BarcodeLabelUpsertComponent,
  'publicQr': () => PublicQrUpsertComponent,
  'public-qr': () => PublicQrUpsertComponent,
  'barcodeCatalog': () => BarcodeCatalogsUpsertComponent,
  'barcode-catalog': () => BarcodeCatalogsUpsertComponent,
  'departments': () => DeparmtentsUpsertComponent,
  'statuses': () => StatusesUpsertComponent,
  'asset-types': () => AssetTypeUpsertComponent,
  'conditions': () => StocksConditionsUpsertComponent,
  'asset-conditions': () => AssetConditionsUpsertComponent,
  'assigned-assets': () => AssignedAssetsPopupComponent,
  'customerTypes': () => CustomerTypesUpsertComponent,
  'reset-password-popup': () => ResetPasswordPopupComponent,
  'asset-models': () => AssetModelUpsertComponent,
  'assets': () => AssetUpsertComponent,
  'asset-inventory': () => AssetUpsertComponent,
  'fundingsource': () => FundingSourceUpsertComponent,
  'copy-barcode-label': () => CopyBarcodeLabelComponent,
  'asset-po-approvals': () => AssetAdminPOApprovalsUpsertComponent,
  'reportDesigner': () => ReportDesignerComponent,
  'asset-purchaseOrders': () => AssetPurchaseOrdersUpsertComponent,
  //'sites' :SitesUpsertComponent
  'sites': () => MultiSiteUpsertComponent,
  'asset-transfer-transaction': () => AssetTransferUpsertComponent,
  'asset-reservation': () => AssetReservationUpsertComponent,
  'asset-models-2': () => AssetModelUpsert2Component,
  'cycle-count': () => CycleCountComponent,
  [PageNames.StockCycleCount]: () => StockCycleCountComponent,
  [PageNames.StockCycleCountAdjust]: () => StockCycleCountAdjustComponent,
  [PageNames.TransactionPhysicalInventory]: () => StockPhysicalInventoryComponent,
  [PageNames.StockPhysicalInventoryTransaction]: () => StockPhysicalInventoryComponent,
  [PageNames.TransactionAdjustInventory]: () => StockAdjustInventoryComponent,
  [PageNames.StockAdjust]: () => StockAdjustInventoryComponent,
  [PageNames.ScheduleMaintenance]: () => ScheduleMaintenanceFormComponent,
  [PageNames.PerformMaintenance]: () => PerformMaintenanceFormComponent,
  [PageNames.MaintenanceType]: () => MaintenanceTypeUpsertComponent,
  [PageNames.SiteTransfers]: () => isEnterpriseMode() ? StocksTransferRequestsUpsertComponent : StocksSiteTransferUpsertComponent,
  'siteTransfers': () => isEnterpriseMode() ? StocksTransferRequestsUpsertComponent : StocksSiteTransferUpsertComponent,
  'siteTransfer': () => isEnterpriseMode() ? StocksTransferRequestsUpsertComponent : StocksSiteTransferUpsertComponent,
  'site-transfer': () => isEnterpriseMode() ? StocksTransferRequestsUpsertComponent : StocksSiteTransferUpsertComponent,
  'transfer-requests': () => StocksTransferRequestsUpsertComponent,
};

export const formComponentMapOptions: formComponentMap = new Proxy({} as formComponentMap, {
  get(target, prop: string | symbol) {
    if (typeof prop === 'string' && prop in componentMap) {
      return componentMap[prop]();
    }
    return Reflect.get(target, prop);
  },
  has(target, prop: string | symbol) {
    return (typeof prop === 'string' && prop in componentMap) || Reflect.has(target, prop);
  },
  ownKeys(target) {
    return Array.from(new Set([...Reflect.ownKeys(target), ...Object.keys(componentMap)]));
  },
  getOwnPropertyDescriptor(target, prop: string | symbol) {
    if (typeof prop === 'string' && prop in componentMap) {
      return {
        configurable: true,
        enumerable: true,
        value: componentMap[prop](),
        writable: false,
      };
    }
    return Reflect.getOwnPropertyDescriptor(target, prop);
  }
});
